module.exports = __webpack_public_path__ + "static/img/fish12.f41c868.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/jiejifish/fish12.png
// module id = cHRX
// module chunks = 0